import React, { useMemo } from "react";

const SideNavigation = () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const joinedDate = useMemo(() => {
    if (!storedUser?.created_at) return "—";
    const parsedDate = new Date(storedUser.created_at);
    if (Number.isNaN(parsedDate.getTime())) return "—";
    return `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(parsedDate.getDate()).padStart(2, "0")}`;
  }, [storedUser?.created_at]);

  return (
    <div className="w-full h-full text-white">
      {/* Make the sidebar scroll if content is tall (good for mobile drawer) */}
      <div className="h-full overflow-y-auto">
        {/* Profile */}
        <div className="px-4 py-5">
          <p className="text-sm text-gray-200">Profile</p>
          <hr className="w-24 border-white/20 mt-3 mb-3" />

          <div className="space-y-6 text-sm font-thin">
            <p className="break-words">
              <span className="font-bold">Email: </span>
              {storedUser?.email || "—"}
            </p>

            <p>
              <span className="font-bold">Role: </span>
              Student
            </p>

            <p>
              <span className="font-bold">Joined: </span>
              {joinedDate}
            </p>
          </div>
        </div>

        {/* Quick Links */}
        <div className="px-4 py-5">
          <p className="text-sm text-gray-200">Quick Links</p>
          <hr className="w-24 border-white/20 mt-3 mb-3" />

          <nav className="flex flex-col">
            <a
              href="/user-dashboard"
              className="rounded-lg px-3 py-2 text-sm hover:bg-white hover:text-black transition"
            >
              Subject Dashboard
            </a>

            <a
              href="/profile"
              className="rounded-lg px-3 py-2 text-sm hover:bg-white hover:text-black transition"
            >
              Edit Profile
            </a>

            {/* Keep your future links ready */}
            {/*
            <a
              href="/progress"
              className="rounded-lg px-3 py-2 text-sm hover:bg-white hover:text-black transition"
            >
              Progress Tracker
            </a>
            */}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default SideNavigation;
